export default __webpack_public_path__ + "static/media/hn-hokensyou.960a13dc.jpg";